/**
 * GlobalSearchProvider — single-source mount for the global search modal.
 *
 * Why: both <DesktopHeader /> and <Dashboard /> need to open the same
 * search experience. Mounting the modal in two places caused conflicts
 * (duplicated ⌘K listeners and overlapping modals). This provider mounts
 * the modal exactly once at the App root and exposes `openSearch` /
 * `closeSearch` through context, so any surface (Dashboard pill, desktop
 * header icon, or future entry points) can drive the same instance.
 */
import React, { createContext, useContext } from 'react';
import { GlobalSearch, useGlobalSearch } from '@/components/GlobalSearch';

const GlobalSearchContext = createContext({
  open: false,
  openSearch: () => {},
  closeSearch: () => {},
});

export const GlobalSearchProvider = ({ children }) => {
  const { open, openSearch, closeSearch } = useGlobalSearch();
  return (
    <GlobalSearchContext.Provider value={{ open, openSearch, closeSearch }}>
      {children}
      <GlobalSearch open={open} onClose={closeSearch} />
    </GlobalSearchContext.Provider>
  );
};

export const useGlobalSearchContext = () => useContext(GlobalSearchContext);
